// src/components/CarsNavbar.jsx
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding-left: 240px; // 🧭 Aligns with sidebar

  @media only screen and (max-width: 768px) {
    padding-left: 10px;
  }
`;

const Warpper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;

  @media only screen and (max-width: 768px) {
    gap: 12px;
  }
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;
  &:hover {
    color: teal;
  }
  color: ${(props) => (props.greeting ? "teal" : "inherit")};
  &:first-child {
    margin-left: 20px;
  }

  @media only screen and (max-width: 768px) {
    &:first-child {
      margin-left: 0;
    }
  }
`;

const CarsNavbar = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Warpper>
        <Left>
          <MenuItem onClick={() => navigate("/")}>Home</MenuItem>
          <MenuItem onClick={() => navigate("/car-design")}>Car Design</MenuItem>
        </Left>

        <Center></Center>

        <Right></Right>
      </Warpper>
    </Container>
  );
};

export default CarsNavbar;
